import React from 'react';
import styles from '../../../../common/utils/styles/css/styles';
import { useTranslation } from 'react-i18next';
import Button from '../../../../common/components/basic/Button';
import { Router } from '../../../../common/libs/i18n';

export default function Rejected() {
  const { t } = useTranslation();
  return (
    <div css={styles.tac}>
      <img alt="" src="/static/images/register/img-registration-rejected.svg" />
      <h1 css={styles.mtm}>
        {t('signin.message.registration.rejected.title', 'Registration rejected')}
      </h1>
      <p>
        {t(
          'signin.message.registration.rejected.subtitle',
          "We're sorry, but your registration has been rejected. If you would like to try again, click the button below."
        )}
      </p>
      <div css={styles.mvm}>
        <Button onClick={() => Router.push('/register/individual/details')}>
          {t('signin.message.email_unverified.subtitle_rejected_button', 'Retry registration')}
        </Button>
      </div>
    </div>
  );
}
